import { LoaderFunctionArgs, redirect } from "react-router-dom";
import Result from "antd/es/result";
import { Button } from "antd";
import { loadListingBrowse } from "~/pages/UnitPages/listingBrowse/loadListingBrowse";
import type { ListingBrowsePageLoaderResult } from "~/types/listing";
import { ROUTES } from "~/utils";

export const PropertyDetailsPageLoader = async ({
  request,
  params,
}: LoaderFunctionArgs) => {
  const propertyID = params.propertyID?.trim() ?? "";
  if (!propertyID) {
    throw redirect(ROUTES.unit);
  }

  return loadListingBrowse(request, {
    lockedPropertyId: propertyID,
    loadPropertyInfo: true,
  });
};

export type PropertyDetailsPageLoaderType = ListingBrowsePageLoaderResult;

export const PropertyDetailsPageErrorBoundary = () => {
  return (
    <Result status="500" title="500" subTitle="Sorry, something went wrong.">
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Button type="primary" href={ROUTES.unit}>
          Back to listings
        </Button>
      </div>
    </Result>
  );
};
